<template>
  <div v-if="invoice">
    <div
      class="mb-6"
      v-for="(session, index) in invoice.sessions"
      :key="session.id"
    >
      <div class="px-4 pt-3 pb-4 bg-gray-100 flex space-x-4  sticky top-0 z-10">
        <sqr-input-date
          class="w-48"
          :label="$t('invoice_session_date')"
          :value="session.date"
          @change="$emit('change', { index, field: 'date', value: $event })"
          :v="v.$each[index].date"
        />
        <!-- <pre>{{v.$each[index].date}}</pre> -->
        <sqr-button
          class="hidden md:block mt-6"
          :label="$t('invoice_session_remove')"
          @click="$emit('remove', { index })"
          color="transparent"
          second="red"
        >
          <template slot="icon">
            <XIcon class="inline w-4 h-4 stroke-current" />
          </template>
        </sqr-button>
        <sqr-button
          class="md:hidden mt-6"
          :label="$t('buttons_remove')"
          @click="$emit('remove', { index })"
          color="transparent"
          second="red"
        >
          <template slot="icon">
            <XIcon class="inline w-4 h-4 stroke-current" />
          </template>
        </sqr-button>
      </div>
      <invoice-lines-form
        class="border-l border-gray-100"
        :date="invoice.date"
        :lines="session.lines"
        :no-taxes="noTaxes"
        @add="$emit('line-add', { sessionIndex: index, ...$event })"
        @change="$emit('line-change', { sessionIndex: index, ...$event })"
        @remove="$emit('line-remove', { sessionIndex: index, ...$event })"
        :v="v.$each[index] && v.$each[index].lines"
      />
    </div>
    <div class="p-4 border-t flex flex-col md:flex-row space-x-2">
      <sqr-button
        :label="$t('invoice_session_add')"
        @click="$emit('add')"
        color="green"
      >
        <template slot="icon">
          <PlusIcon class="inline w-4 h-4 stroke-current" />
        </template>
      </sqr-button>

      <sqr-button
        v-show="invoice.sessions && invoice.sessions.length > 1"
        :label="$t('invoice_line_sort_date')"
        @click="$emit('sort', { field: 'date', direction: 'asc' })"
        color="white"
      >
        <template slot="icon">
          <SortDescendingIcon class="inline w-4 h-4 stroke-current" />
        </template>
      </sqr-button>
    </div>
  </div>
</template>

<script>
import SqrInputDate from '@/components/SqrInputDate';
import SqrButton from '@/components/SqrButton';
import InvoiceLinesForm from '@/forms/InvoiceLinesForm';
import { SortDescendingIcon, XIcon } from '@vue-hero-icons/outline';

export default {
  name: 'InvoiceSessionsForm',
  components: {
    SqrInputDate,
    SqrButton,
    InvoiceLinesForm,
    XIcon,
    SortDescendingIcon
  },
  props: {
    invoice: {
      type: Object,
      default: () => {
        [];
      }
    },
    v: Object,
    noDates: Boolean,
    noAmounts: Boolean,
    noModels: Boolean,
    noTaxes: Boolean
  }
};
</script>
